import { render, staticRenderFns } from "./CharityDonations.vue?vue&type=template&id=70d2e017"
import script from "./CharityDonations.vue?vue&type=script&lang=js"
export * from "./CharityDonations.vue?vue&type=script&lang=js"
import style0 from "./CharityDonations.vue?vue&type=style&index=0&id=70d2e017&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports